import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSubstituteChild = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M11.519 12.1381C11.8225 11.8347 11.8225 11.344 11.519 11.0437C11.3872 10.9133 11.22 10.8389 11.0485 10.8214C10.9957 10.816 10.9425 10.816 10.8897 10.8214C10.7195 10.8388 10.5543 10.9127 10.4247 11.0437L8.64911 12.8193L8.78994 10.8214L8.78994 1.77538C8.78994 1.34602 8.30046 1.0006 7.8711 1.0006C7.44174 1.0006 6.81881 1.34602 6.81881 1.77538L6.80001 10.8214L7.09631 12.8193L5.32077 11.0437C5.1921 10.9151 5.02978 10.841 4.86258 10.8214C4.63544 10.7948 4.39932 10.8689 4.22638 11.0437C3.92616 11.3472 3.92293 11.8379 4.22638 12.1381L7.32229 15.2373C7.62575 15.5407 8.11645 15.5407 8.41668 15.2373L11.5158 12.1381L11.519 12.1381Z",
			fill: "#FF6B00"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.64911 12.8193L10.4247 11.0437C10.5543 10.9127 10.7195 10.8388 10.8897 10.8214L8.78994 10.8214L8.64911 12.8193Z",
			fill: "#FF6B00"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.09631 12.8193L6.80001 10.8214L4.86258 10.8214C5.02978 10.841 5.1921 10.9151 5.32077 11.0437L7.09631 12.8193Z",
			fill: "#FF6B00"
		})
	]
});
export default SvgSubstituteChild;
